import { render } from "./edit_vendor.vue?vue&type=template&id=6878c8bf"
import script from "./edit_vendor.vue?vue&type=script&lang=js"
export * from "./edit_vendor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__